const AuthorizationNameSpace = 'authorization';

const AuthorizationActionTypes = Object.freeze({
    Login: 'Login',
    Logout: 'Logout',
    Precheck: 'Precheck',
});

const AuthorizationMutationTypes = Object.freeze({});

const AuthorizationGetterTypes = Object.freeze({});

export {
    AuthorizationNameSpace,
    AuthorizationActionTypes,
    AuthorizationMutationTypes,
    AuthorizationGetterTypes,
};